{
  "version": 1,
  "asset_id": "4f58fa48-05bc-44c8-826f-499dcb013d20",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/4f58fa48-05bc-44c8-826f-499dcb013d20/destination-roofing-owner-dump-trailer-crystal-river-fl-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/4f58fa48-05bc-44c8-826f-499dcb013d20/destination-roofing-owner-dump-trailer-crystal-river-fl-768w.webp",
  "original_filename": "destination-roofing-owner-dump-trailer-crystal-river-fl-768w.webp",
  "size": 46160,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:40Z"
}
